import React, { useEffect, useState } from "react";
import { BUDGET_BANDS, LEAD_TIME_BANDS, RESPONSE_BANDS, TIER_BANDS } from "./labels";

const sel = "bg-white border border-clay-300 px-2 py-1.5 text-sm outline-none focus:border-terracotta";

export function Filters({ value, onChange, agents, destinations }) {
  const set = (k, v) => onChange({ ...value, [k]: v });
  const [q, setQ] = useState(value.q || "");
  useEffect(() => { setQ(value.q || ""); }, [value.q]);
  useEffect(() => {  // debounce the free-text search (2 heavy requests per change)
    if ((q || undefined) === (value.q || undefined)) return undefined;
    const t = setTimeout(() => set("q", q || undefined), 350);
    return () => clearTimeout(t);
  }, [q]);  // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <div className="flex flex-wrap items-end gap-2" data-testid="kimkim-filters">
      <label className="block"><span className="text-[11px] text-clay-600 block mb-1">Agente</span>
        <select className={sel} value={value.agent ?? ""} onChange={(e) => set("agent", e.target.value === "" ? undefined : e.target.value)} data-testid="kimkim-filter-agent">
          <option value="">Todos</option>
          <option value="__none__">Sin asignar</option>
          {agents.map((a) => <option key={a.email} value={a.email}>{a.name}</option>)}
        </select></label>
      <label className="block"><span className="text-[11px] text-clay-600 block mb-1">Desde</span>
        <input type="date" className={sel} value={value.date_from || ""} onChange={(e) => set("date_from", e.target.value || undefined)} data-testid="kimkim-filter-from"/></label>
      <label className="block"><span className="text-[11px] text-clay-600 block mb-1">Hasta</span>
        <input type="date" className={sel} value={value.date_to || ""} onChange={(e) => set("date_to", e.target.value || undefined)} data-testid="kimkim-filter-to"/></label>
      <label className="block"><span className="text-[11px] text-clay-600 block mb-1">Destino</span>
        <select className={sel} value={value.destination || ""} onChange={(e) => set("destination", e.target.value || undefined)} data-testid="kimkim-filter-destination">
          <option value="">Todos</option>
          {destinations.map((d) => <option key={d} value={d}>{d}</option>)}
        </select></label>
      <label className="block"><span className="text-[11px] text-clay-600 block mb-1">Categoría KimKim</span>
        <select className={sel} value={value.tier || ""} onChange={(e) => set("tier", e.target.value || undefined)} data-testid="kimkim-filter-tier">
          <option value="">Todas</option>
          {Object.entries(TIER_BANDS).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
        </select></label>
      <label className="block"><span className="text-[11px] text-clay-600 block mb-1">Presupuesto/persona</span>
        <select className={sel} value={value.budget_band || ""} onChange={(e) => set("budget_band", e.target.value || undefined)} data-testid="kimkim-filter-budget">
          <option value="">Todos</option>
          {Object.entries(BUDGET_BANDS).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
        </select></label>
      <label className="block"><span className="text-[11px] text-clay-600 block mb-1">Antelación</span>
        <select className={sel} value={value.lead_time_band || ""} onChange={(e) => set("lead_time_band", e.target.value || undefined)} data-testid="kimkim-filter-leadtime">
          <option value="">Todas</option>
          {Object.entries(LEAD_TIME_BANDS).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
        </select></label>
      <label className="block"><span className="text-[11px] text-clay-600 block mb-1">1ª respuesta</span>
        <select className={sel} value={value.response_band || ""} onChange={(e) => set("response_band", e.target.value || undefined)} data-testid="kimkim-filter-response">
          <option value="">Todas</option>
          {Object.entries(RESPONSE_BANDS).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
        </select></label>
      <label className="block flex-1 min-w-[160px]"><span className="text-[11px] text-clay-600 block mb-1">Buscar</span>
        <input className={`${sel} w-full`} placeholder="viajero, destino, especialista…" value={q} onChange={(e) => setQ(e.target.value)} data-testid="kimkim-filter-q"/></label>
      {Object.values(value).some((v) => v !== undefined && v !== "") && (
        <button onClick={() => onChange({})} className="text-[11px] uppercase tracking-wider text-clay-600 hover:text-clay-900 pb-2" data-testid="kimkim-filter-clear">Limpiar</button>
      )}
    </div>
  );
}
